export default "__VITE_ASSET__cad2c062__"